import { saveAs } from 'file-saver';
import { LoaderService } from './../../../../_services/loader.service';
import { LocationService } from './../../../../_services/location.service';
import { CmsService } from './../../../../_services/strapi.service';
import { MerchantService } from './../../../../_services/merchant.service';
import { Component, inject, OnInit } from '@angular/core';
import { File, Pdf } from 'src/app/_models/strapi-file';


@Component({
    selector: 'app-payment-methods',
    templateUrl: './payment-methods.component.html',
    styleUrls: ['./payment-methods.component.scss'],
    standalone: false
})
export class PaymentMethodsComponent implements OnInit {
  private readonly cmsService: CmsService = inject(CmsService);
  private readonly locationService: LocationService = inject(LocationService);
  private readonly loaderService: LoaderService = inject(LoaderService);
  
  public merchantService: MerchantService = inject(MerchantService);

  listPdf: Array<Pdf> = [];
  currentLanguage: string;

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.cmsService.getDocuments().subscribe(
      pdfs => {
        this.listPdf = pdfs;
        this.loaderService.stopLoader();
      },
      error => this.loaderService.stopLoader()
      );

    this.locationService.currentLanguage$.subscribe(resp => this.currentLanguage = resp);
  }

  openPdf(file: File) {

    if(!file) {
      return;
    } else {
      this.cmsService.downloadFile(file.url).subscribe(blob => {
        saveAs(blob, `${file.name}`);
      }
    );
    }

  }

  showPdf(pdf: Pdf) {
    if (!pdf) return false;

    return pdf.visibility === 'public' || 
      (pdf.visibility === 'private' && (this.merchantService.currentMerchantRoleOneOf(["USER", "SANDBOX_USER"])));
  }

}
